module.exports = __webpack_public_path__ + "static/media/02_Trophy (ft Imenella)_rvsd 02-27.ab48d369.mp3";